import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Istantaneo', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia di 7 Giorni'];
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-109" data-mp="4lql31pohn65">
      <div className="mx-auto max-w-4xl text-center" data-id="element-110" data-mp="4na0kq3ifu6v">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-111" data-mp="12a0mpfljy8wq">
          Risolvi un Intero Anno di Lezioni di Storia in soli{' '}
          <span className="italic text-brand" data-id="element-112" data-mp="neauv0tor1k3">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: EASE
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-113" data-mp="3d33f4zea6vla">
          Unisciti a oltre 1.800 insegnanti che hanno smesso di improvvisare. Entra in classe con
          tutto pronto per spiegare, viaggiare nel tempo e appassionare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: EASE
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-114" data-mp="3e8mtl1bhqrfo">
          <img src="https://cdn.magicpatterns.com/uploads/1ZxphDUMnuVVHhNeomVJbm/77d821d3-c777-4e83-9244-3cdb69f97405.webp" alt="Il pacchetto STORIA PRONTA: gli otto volumi dalla 1ª Primaria alla 3ª Media con mappe concettuali, linee del tempo, verifiche inclusive e i 5 bonus strategici inclusi" className="mx-auto w-[70%] max-w-sm sm:w-[66%]" data-id="element-115" data-mp="35audvw1uxhrr" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: EASE
      }} className="-mt-2 sm:mt-8" data-id="element-116" data-mp="s21h48i0i7ye">
          <CtaButton href="#offer" data-id="element-117" data-mp="ibyo48aw4u02" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-118" data-mp="id03uq2uq4o4">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-119" data-mp="1azuk1asmyhvs" data-mpi={index}>
                <span data-id="element-120" data-mp="1622hlmud7ddc">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-121" data-mp="112pvx5f8cccc">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}